import {LreSender} from './lre-sender';
import {LreRecipient} from './lre-recipient';

export class Lre {
  public subject: string;
  public comments: string;
  public trtChainName: string;
  public origin: string;
  public sender: LreSender;
  public recipient: LreRecipient;

  constructor(customerID: string) {
    this.subject = '';
    this.comments = '';
    this.trtChainName = '';
    this.origin = 'Web';
    this.sender = new LreSender(customerID);
    this.recipient = new LreRecipient();
  }
  public stringify(): string {
    this.sender.address = this.sender.address[0].split('\n');
    this.recipient.address = this.recipient.address[0].split('\n');
    return JSON.stringify(this);
  }
  public isValid(): boolean {
    return this.subject !== ''
      && this.recipient.isValid()
      && this.sender.isValid();
  }
  public getValidationErrors(): string[] {
    const errors: string[] = [];
    if (this.subject === '') {
      errors.push('UPLOAD_COMPONENT.LRE_SUBJECT_REQUIRED');
    }
    if (!this.sender.isValid()) {
      errors.push('UPLOAD_COMPONENT.LRE_SENDER_INVALID');
    }
    if (!this.recipient.isValid()) {
      errors.push('UPLOAD_COMPONENT.LRE_RECIPIENT_INVALID');
    }
    return errors;
  }

}
